import type { AvailableIconName } from '@/assets/icons';
import { STRINGS } from '@/constants/strings';

import type { CoachNotificationPreferenceKey } from './types';

const strings = STRINGS.coach.notificationPreferences;

export type CoachNotificationPreferenceRowConfig = {
  key: CoachNotificationPreferenceKey;
  title: string;
  description: string;
  icon: AvailableIconName;
};

export const COACH_NOTIFICATION_PREFERENCE_ROWS: CoachNotificationPreferenceRowConfig[] = [
  {
    key: 'classReminders',
    title: strings.options.classReminders.title,
    description: strings.options.classReminders.description,
    icon: 'IcNotification',
  },
  {
    key: 'bookingActivities',
    title: strings.options.bookingActivities.title,
    description: strings.options.bookingActivities.description,
    icon: 'IcNotificationClass',
  },
  {
    key: 'system',
    title: strings.options.system.title,
    description: strings.options.system.description,
    icon: 'IcNotificationSettingsFill',
  },
];

export const DEFAULT_COACH_NOTIFICATION_PREFERENCES = {
  classReminders: true,
  bookingActivities: true,
  system: true,
} as const;
